export enum EntityType {
    Person = 1,
    Company = 2,
    Asset = 3,
    Action = 4
}